module.exports = __webpack_public_path__ + "5cbcc9480c4f1f53e1164ef8a92fab50.pdf";